import { CompanyInterface } from '../company.interface'

export const getCompanySettingsInitialValues = (form?: CompanyInterface) => {
  if (form) {
    return {
      companyName: form.companyName ?? null,
      companyInn: form.companyInn ?? null,
      companyOgrn: form.companyOgrn ?? null,
      text: null,
    }
  }

  return {
    companyName: null,
    companyInn: null,
    companyOgrn: null,
    text: null,
  }
}
